//MAP de las solicitudes desde backend y las redirecciones desde front para las notificaciones
import { RequestType } from '@/modules/support/types/RequestType.ts'
import { FrontPathUrl } from '@/core/types/FrontPathUrl.ts'

export type NotificationType = RequestType | 'CREACIÓN DE VIDEO'

interface FrontendRouteInfo {
  frontPath: FrontPathUrl
  requestType: NotificationType
}

export type BackUrl =
  | 'credit-change-requests'
  | 'client-editing-requests'
  | 'credit-editing-requests'
  | 'credit-reassign-requests'
  | 'credit-deletion-requests'
  | 'warranty-requests'
  | 'video'

export const requestTypeMapping: Record<BackUrl, FrontendRouteInfo> = {
  'credit-change-requests': {
    frontPath: '/support/article-change-request',
    requestType: 'ARTICLE_CHANGE'
  },
  'client-editing-requests': {
    frontPath: '/support/client-edit-request',
    requestType: 'CLIENT_EDIT'
  },
  'credit-editing-requests': {
    frontPath: '/support/article-edit-request',
    requestType: 'ARTICLE_EDIT'
  },
  'credit-reassign-requests': {
    frontPath: '/support/article-reassign-request',
    requestType: 'ARTICLE_REASSIGN'
  },
  'credit-deletion-requests': {
    frontPath: '/support/article-delete-request',
    requestType: 'ARTICLE_DELETE'
  },
  'warranty-requests': {
    frontPath: '/support/release-request',
    requestType: 'WARRANTY_RELEASE'
  },
  video: {
    frontPath: '/teaching/videoList',
    requestType: 'CREACIÓN DE VIDEO'
  }
}
